module.exports = __webpack_public_path__ + "media/ppc/today-ff346d8c.png";